
<div class="container" [ngClass]="{'general-disabled': deployment?.isMigrationActive}">
  <div class="row">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row" *ngIf="partnerApiSuccess.length &gt; 0">
    <div class="col">
      <div class="alert alert-success"><span>{{ partnerApiSuccess }}</span></div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <p class="text-center">Send installation data to the project's partner</p>
    </div>
  </div>
  <div class="row">
    <div class="col"> </div>
    <div class="col"><a class="btn btn-primary btn-block" [downloadFile]="'/api/DeploymentWorkflow/export-partner-install'" [params]="{deploymentId: deploymentId, projectId: projectId}"><span class="oi oi-cloud-download"></span> Export Partner Installation Form</a></div>
    <div class="col" *ngIf="allowSendingToPartner.valid"> </div>
    <div class="col" *ngIf="allowSendingToPartner.valid"><a class="btn btn-primary btn-block" href="javascript:void(0)" (click)="sendDeployToPartner()"><span class="oi oi-envelope-closed"></span> Send Deployment to Installation Partner</a></div>
    <div class="col"> </div>
  </div>
</div>